export const LANGUAGES = [
    {
        label: 'Français',
        code: 'fr',
        flagIcon: 'flag-icon-fr',
    },
    {
        label: 'English',
        code: 'en',
        flagIcon: 'flag-icon-gb',
    },
];
